import { base64url, getDomain, getPubkeyParams, getUniqId, handleProductType, stringToArrayBuffer } from "common/method/helper"
import Cookies from "js-cookie"
import Axios from '../../../apiConfig/Axios';
import apiRoutes from "services/apiRoutes";



export const useFingerPrint = (searchParams?: URLSearchParams) => {

    const makeAssertionOptions = (options?: PublicKeyCredentialRequestOptions) => {
        // make options
        const assertionOptions: PublicKeyCredentialRequestOptions | undefined = {
            allowCredentials: [],
            challenge: base64url.decode(options?.challenge),
            extensions: {
                txAuthSimple: "",
            },
            rpId: options?.rpId,
            timeout: 60000,
        };

        // Set options
        options?.allowCredentials && options?.allowCredentials.forEach((listItem: any) => {
            assertionOptions.allowCredentials?.push({
                id: base64url.decode(listItem.id),
                transports: ["internal"],
                type: "public-key",
            });
            listItem.id = base64url.decode(listItem.id);
            listItem.transports = ["internal"];
            listItem.type = "public-key";
        });

        return assertionOptions;
    };



    const loginAssertOption = (fingerId?: string) => new Promise<PublicKeyCredentialRequestOptions>(async (done, reject) => {
        try {
            if (
                typeof window.PublicKeyCredential === "function" &&
                navigator &&
                navigator.credentials
            ) {
                const { data } = await Axios.post(apiRoutes.fingerPrint.assertionOptionsV2, {

                    fingerId,
                    userVerification: "Required",
                    brokerCode: String(window.api.BROKER_CODE),
                })

                done(data)
            }
        } catch (err) {
            reject("Reject-login-AssertOption:" + err)
        }
    })

    const loginWebAuth = (options?: PublicKeyCredentialRequestOptions) => new Promise<makeAssertType>(async (resolve, reject) => {
        if (
            Array.isArray(options?.allowCredentials) &&
            options?.allowCredentials &&
            options?.allowCredentials?.length > 0
        ) {
            const assertionOptions = makeAssertionOptions(options);

            // @ts-ignore: Unreachable code error
            navigator.credentials.get({
                publicKey: assertionOptions
            })
                .then((r) => {
                    resolve({
                        assertion: r,
                        options: assertionOptions
                    });
                })
                .catch((err) => {
                    reject("login-Web-Auth" + err);
                });
        } else {
            alert("options?.allowCredentials in empty")
        }
    })

    const loginMakeAssert = ({ assertion, options }: makeAssertType) => new Promise<GlobalApiResponseType<responseAuthorizationType>>(async (resolve, reject) => {
        try {
            if (!assertion) return

            const { data } = await Axios.post(apiRoutes.fingerPrint.makeAssertionV2, {
                response: {
                    id: assertion.id,
                    rawId: base64url.encode(assertion.rawId),
                    response: {
                        authenticatorData: base64url.encode(assertion.response.authenticatorData),
                        clientDataJSON: base64url.encode(assertion.response.clientDataJSON),
                        signature: base64url.encode(assertion.response.signature),
                        userHandle: null
                    },
                    type: 'PublicKey'
                },
                options: {
                    ...options,
                    extensions: {},
                    challenge: base64url.encode(options.challenge),
                    allowCredentials: options?.allowCredentials?.map((item: any) => ({
                        type: 'PublicKey',
                        id: base64url.encode(item.id),
                        transports: null
                    })),
                    userVerification: "Required"
                },
                brokerCode: String(window.api.BROKER_CODE),
                // userName: "soheilkh",
                fingerId: Cookies.get("fingerId"),
                pt: searchParams ? handleProductType(searchParams) : 'Mobile'
            })

            resolve(data)

        } catch (err) {
            reject("reject-login-MakeAssert" + err)
        }
    })

    const registerMakeCredentialOption = () => new Promise(async (done, reject) => {
        try {
            const fingerId = getUniqId()

            Cookies.set("fingerId", fingerId, {
                domain: getDomain(),
                path: '/',
                secure: true,
                sameSite: 'Lax',
                expires: 30
            })

            const formData = new FormData();
            // formData.append("displayName", "");
            formData.append("fingerId", fingerId);
            formData.append("attType", "direct");
            formData.append("authType", "platform");
            formData.append("requireResidentKey", "false");
            formData.append("brokerCode", String(window.api.BROKER_CODE));
            formData.append("userVerification", "discouraged");

            const { data } = await Axios.post(apiRoutes.fingerPrint.makeCredentialOptionsV2, formData)

            if (!data) {
                reject("Da ta not available")
            }

            done(data)

        } catch (err) {
            reject("reject-register-MakeCredentialOption" + err)
        }
    })

    const registerWebAuth = (data: any) => new Promise(async (done, reject) => {
        try {

            const excludeCredential: PublicKeyCredentialDescriptor = {
                id: new Uint8Array(16),
                type: "public-key",
                transports: ["internal"],
            };

            const publicKey: PublicKeyCredentialCreationOptions = {
                ...data,
                rp: {
                    ...data.rp,
                },
                pubKeyCredParams: getPubkeyParams(data.pubKeyCredParams),
                authenticatorSelection: {
                    ...data.authenticatorSelection,
                    authenticatorAttachment: data.authenticatorSelection.authenticatorAttachment,
                },
                excludeCredentials: [excludeCredential],
                challenge: stringToArrayBuffer(String(data.challenge)),
                user: {
                    ...data.user,
                    id: stringToArrayBuffer(String(data.user.id)),
                    fingerId: Cookies.get("fingerId")
                },
            }

            const promiseFullFill: any = await navigator.credentials.create({ publicKey });

            if (!promiseFullFill) throw new Error("Permission denied!");

            const credentialResponse: any = {
                options: {
                    ...data,
                    challenge: base64url.encode(publicKey.challenge),
                },
                response: {
                    id: base64url.encode(promiseFullFill.rawId),
                    rawId: base64url.encode(promiseFullFill.rawId),
                    response: {
                        attestationObject: base64url.encode(promiseFullFill.response.attestationObject),
                        clientDataJSON: base64url.encode(promiseFullFill.response.clientDataJSON),
                    },
                    type: "PublicKey",
                },
                brokerCode: String(window.api.BROKER_CODE),
                // userName: user.userName,
                fingerId: Cookies.get("fingerId"),
            };
            done(credentialResponse)

        } catch (err) {
            reject("reject-register-WebAuth:" + err)
        }
    })


    const registerMakeCredential = (item: any) => new Promise<{ status: string }>(async (done, reject) => {
        try {
            const { data } = await Axios.post(apiRoutes.fingerPrint.makeCredentialV2, item)
            done(data)
        } catch (err) {
            reject("reject , register-MakeCredential" + err)
        }
    })




    return {
        loginAssertOption,
        loginWebAuth,
        loginMakeAssert,
        registerMakeCredentialOption,
        registerWebAuth,
        registerMakeCredential
    }
}